import React from 'react';

function AdminSkills() {
  return (
    <div>
      <h1>Admin Skills</h1>
    </div>
  );
}

export default AdminSkills;
